import BSHtmlBaseBillableStrategy from './BSHtmlBaseBillableStrategy'

export default function BSHtmlAvrgRatesStrategy() {}

BSHtmlAvrgRatesStrategy.prototype = new BSHtmlBaseBillableStrategy()

BSHtmlAvrgRatesStrategy.prototype.addFirstHeaderRowCells = function(row, levelsNumber) {
    this.addCell(row, this.message("report.billing_summary.average_rate.html", [SystemSettings.currencySign]),
        "averageRate", 1, levelsNumber)
}

BSHtmlAvrgRatesStrategy.prototype.addColumnValueCells = function(row) {
    this.addMoneyValueCell(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlAvrgRatesStrategy.js